import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const tipoServico = '/service/contabilidade/empenho/'

class TipoServicoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getTipoServicos() {
        return this.conex.get(tipoServico + 'listaTipoServico/')
    }
}

export default TipoServicoService
